import React, { useContext, useMemo } from "react";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import { EntityType } from "module/entity/types";
import MaintenanceTaskToBeSignedDetailsPersonnelAssignmentsExternalStaff from "pages/maintenanceTaskToBeSignedDetails/personnelAssignment/externalList/MaintenanceTaskToBeSignedDetailsPersonnelAssignmentsExternalStaff";

const MaintenanceTaskToBeSignedDetailsPersonnelAssignmentsExternalStaffContainer: React.FC =
  () => {
    const { entity } = useContext(MaintenanceTaskContext);
    const maintenanceTask = entity as MaintenanceTaskInterface;

    const entityIdentifiers = useMemo(
      () =>
        maintenanceTask.personnelAssignments.filter(
          (personnelAssignmentEntityIdentifier) =>
            personnelAssignmentEntityIdentifier.type ===
            EntityType.maintenanceTaskPersonnelAssignmentExternalStaff
        ),
      [maintenanceTask.personnelAssignments]
    );

    return (
      <MaintenanceTaskToBeSignedDetailsPersonnelAssignmentsExternalStaff
        {...{
          entityIdentifiers,
        }}
      />
    );
  };

export default React.memo(
  MaintenanceTaskToBeSignedDetailsPersonnelAssignmentsExternalStaffContainer
);
